export default "__VITE_ASSET__CMQ$ehUI__"